export const worldMeta = {
  id: "FW-46",
  name: "Chalkline",
  slug: "chalkline",
  title: "Chalkline — a Fable World: education platform page",
  description:
    "An original education landing page designed by Fable: a pinboard collage with a chalk-dust cursor field, board green and paper."
} as const;

export type WorldMeta = typeof worldMeta;

/**
 * The registry contract: src/worlds/registry.ts globs `world.meta.ts` and reads the
 * NAMED export `meta`. W1-5 shipped these two worlds through their own per-world HTML
 * entry, which read the default export, so `meta` was never here and the glob dropped
 * both worlds silently. Both names are exported now; `meta` is the one that matters.
 */
export const meta = worldMeta;
export default worldMeta;
